export default "__VITE_ASSET__CQJvXs28__"